$(document).ready(function () {
  function monitorURLChanges() {
    // Store the initial URL
    var currentURL = window.location.href;

    // Check for URL changes at regular intervals
   setInterval(function() {
        var newURL = window.location.href;

        // Compare the current URL with the new URL
        if (newURL !== currentURL) {
            // The URL has changed, do something with the updated URL
            // console.log('URL has changed to: ' + newURL);
          location.reload(newURL);
            
            // Update the current URL
            // currentURL = newURL;
        }
    }, 800); // Check every 1 second (adjust the interval as needed)
  }
  // Call the function to start monitoring URL changes

  $(document).on('click','.tvproduct-colour',function(){
    monitorURLChanges();
  });

  $('.product-form__input--dropdown select').change(function() {
        monitorURLChanges();
    });
    $(document).on('click','.js.product-form__input label',function(){
monitorURLChanges();
  });
});